import { render, staticRenderFns } from "./OrderKidsListDialog.vue?vue&type=template&id=1a6f10a0&scoped=true"
import script from "./OrderKidsListDialog.vue?vue&type=script&lang=js"
export * from "./OrderKidsListDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderKidsListDialog.vue?vue&type=style&index=0&id=1a6f10a0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6f10a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a6f10a0')) {
      api.createRecord('1a6f10a0', component.options)
    } else {
      api.reload('1a6f10a0', component.options)
    }
    module.hot.accept("./OrderKidsListDialog.vue?vue&type=template&id=1a6f10a0&scoped=true", function () {
      api.rerender('1a6f10a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/finance/OderKids/OrderKidsListDialog.vue"
export default component.exports